var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.9375C17.28 11.0361 19.1164 11.6263 21 11.625V7.875C19.6076 7.875 18.2723 7.32188 17.2877 6.33731C16.3031 5.35274 15.75 4.01739 15.75 2.625H12V14.625C12 15.0948 11.8739 15.5559 11.6349 15.9603C11.3959 16.3647 11.0528 16.6976 10.6413 16.9242C10.2298 17.1508 9.76502 17.2629 9.29548 17.2486C8.82594 17.2344 8.36882 17.0944 7.97181 16.8433C7.5748 16.5922 7.25245 16.2392 7.03838 15.821C6.82432 15.4029 6.72639 14.9349 6.75481 14.466C6.78323 13.9971 6.93695 13.5445 7.19995 13.1552C7.46294 12.766 7.82557 12.4544 8.25 12.2531V8.35312C7.05617 8.56716 5.94816 9.11732 5.05605 9.93901C4.16394 10.7607 3.52474 11.8198 3.21349 12.9921C2.90224 14.1643 2.93185 15.4011 3.29885 16.5571C3.66585 17.7131 4.355 18.7404 5.28541 19.5185C6.21583 20.2965 7.34889 20.793 8.5516 20.9497C9.7543 21.1063 10.9767 20.9166 12.0754 20.4029C13.1741 19.8891 14.1034 19.0726 14.7543 18.0492C15.4052 17.0257 15.7506 15.8379 15.75 14.625V9.9375Z",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.e9bde91327ce4192160f0e7bbe2ee73b.svg";
export { ForwardRef as ReactComponent };